import { ChangeEvent, useCallback, useState } from 'react'
import { Button, debounce, InputAdornment, MenuItem, TextField } from '@mui/material'
import usePermissionsStore from '../../../stores/permissions'
import InputBase from '@mui/material/InputBase'
import SearchIcon from '@mui/icons-material/Search'
import AddIcon from '@mui/icons-material/Add'
import useCreateUserDialog from '../../../hooks/useCreateUserDialog'

const Header = () => {
  const search = usePermissionsStore(state => state.searchOptions.search)
  const status = usePermissionsStore(state => state.searchOptions.status)
  const updateSearchOptions = usePermissionsStore(state => state.updateSearchOptions)

  const [searchValue, setSearchValue] = useState<string>(search)

  const openCreateUserDialog = useCreateUserDialog()

  const updateDebounce = useCallback(debounce((value: string) => {
    updateSearchOptions({ search: value })
  }, 500), [])

  const handleUpdateSearchDebounce = (e: ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value)
    updateDebounce(e.target.value)
  }

  return (
    <div className="header">
      <InputBase
        className="search"
        placeholder="Search users by name or email"
        size="medium"
        value={searchValue}
        onChange={handleUpdateSearchDebounce}
        startAdornment={
          <InputAdornment position="start">
            <SearchIcon />
          </InputAdornment>
        } />
      <TextField
        size="small"
        sx={{ minWidth: 210 }}
        id="outlined-select-currency"
        select
        label="Status"
        value={status}
        onChange={(e: ChangeEvent<HTMLInputElement>) => updateSearchOptions({ status: e.target.value })}
      >
        <MenuItem value="">All</MenuItem>
        <MenuItem value="active">Active</MenuItem>
        <MenuItem value="disabled">Disabled</MenuItem>
      </TextField>
      <Button
        variant="contained"
        endIcon={<AddIcon />}
        onClick={() => openCreateUserDialog()}
      >
        Create User
      </Button>
    </div>
  )
}

export default Header
